// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

.extension-library-item_library-item_ZHnXy {
    flex-basis: 300px;
    max-width: 300px;
}

.extension-library-item_library-item-image-container_OKjXI {
    position: relative;
    width: 100%;
}

.extension-library-item_library-item-image_Xch1R {
    width: 100%;
    aspect-ratio: 2;
}

.extension-library-item_library-item-metadata_GUj3j {
    grid-template-columns: 1fr 1fr;
}

.extension-library-item_disabled_uW9NT {
    opacity: .5;
    cursor: auto;
}

.extension-library-item_disabled_uW9NT:hover {
    border-color: var(--ui-black-transparent);
}

.extension-library-item_coming-soon-text_Q83xo {
    position: absolute;
    background-color: var(--data-primary);
    border-radius: 1rem;
    box-shadow: 0 0 .5rem hsla(0, 0%, 0%, .25);
    padding: .5rem 1rem;
    font-size: .875rem;
    font-weight: bold;
    color: var(--ui-white);
}

[dir="ltr"] .extension-library-item_coming-soon-text_Q83xo {
    transform: translate(calc(2 * 0.5rem), calc(2 * 0.5rem));
}

[dir="rtl"] .extension-library-item_coming-soon-text_Q83xo {
    transform: translate(calc(-2 * 0.5rem), calc(2 * 0.5rem));
}
`, "",{"version":3,"sources":["webpack://./src/components/library-item/extension-library-item.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,qCAAqC;IACrC,mBAAmB;IACnB,0CAA0C;IAC1C,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;IACI,yDAAyD;AAC7D","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n.library-item {\n    flex-basis: 300px;\n    max-width: 300px;\n}\n\n.library-item-image-container {\n    position: relative;\n    width: 100%;\n}\n\n.library-item-image {\n    width: 100%;\n    aspect-ratio: 2;\n}\n\n.library-item-metadata {\n    grid-template-columns: 1fr 1fr;\n}\n\n.disabled {\n    opacity: .5;\n    cursor: auto;\n}\n\n.disabled:hover {\n    border-color: var(--ui-black-transparent);\n}\n\n.coming-soon-text {\n    position: absolute;\n    background-color: var(--data-primary);\n    border-radius: 1rem;\n    box-shadow: 0 0 .5rem hsla(0, 0%, 0%, .25);\n    padding: .5rem 1rem;\n    font-size: .875rem;\n    font-weight: bold;\n    color: var(--ui-white);\n}\n\n[dir=\"ltr\"] .coming-soon-text {\n    transform: translate(calc(2 * 0.5rem), calc(2 * 0.5rem));\n}\n\n[dir=\"rtl\"] .coming-soon-text {\n    transform: translate(calc(-2 * 0.5rem), calc(2 * 0.5rem));\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `extension-library-item_library-item_ZHnXy`;
export { _1 as "library-item" };
export var libraryItem = `extension-library-item_library-item_ZHnXy`;
var _2 = `extension-library-item_library-item-image-container_OKjXI`;
export { _2 as "library-item-image-container" };
export var libraryItemImageContainer = `extension-library-item_library-item-image-container_OKjXI`;
var _3 = `extension-library-item_library-item-image_Xch1R`;
export { _3 as "library-item-image" };
export var libraryItemImage = `extension-library-item_library-item-image_Xch1R`;
var _4 = `extension-library-item_library-item-metadata_GUj3j`;
export { _4 as "library-item-metadata" };
export var libraryItemMetadata = `extension-library-item_library-item-metadata_GUj3j`;
export var disabled = `extension-library-item_disabled_uW9NT`;
var _5 = `extension-library-item_coming-soon-text_Q83xo`;
export { _5 as "coming-soon-text" };
export var comingSoonText = `extension-library-item_coming-soon-text_Q83xo`;
export default ___CSS_LOADER_EXPORT___;
